import styled from 'styled-components';
import {TiPlus} from 'react-icons/ti';

export const Tiplus = styled(TiPlus)`
  color: #F31B05;
`
